import React from "react";
import ReactDOM from "react-dom/client";
import APP from './APP';
import { BrowserRouter } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<BrowserRouter><APP/></BrowserRouter>);